import React from 'react'
import Heading from '../Reuse/Heading'
import IncomeCard from '../Reuse/IncomeCard'
import { BsCurrencyDollar } from "react-icons/bs";
import { AiFillAudio } from "react-icons/ai"

function AuditionIncome() {
  return (
    <>
          <div className="row">
               <Heading title={"Audition"} icon={<AiFillAudio size={50} />}/>
               <IncomeCard title={"Total"} amount={"120"} id={1} icon={<BsCurrencyDollar size={50} />} />
               <IncomeCard title={"Daily"} amount={"120"} id={1} icon={<BsCurrencyDollar size={50} />} />
               <IncomeCard title={"Weekly"} amount={"120"} id={1} icon={<BsCurrencyDollar size={50} />} />
               <IncomeCard title={"Monthly"} amount={"120"} id={1} icon={<BsCurrencyDollar size={50} />} />
               <IncomeCard title={"Yearly"} amount={"120"} id={1} icon={<BsCurrencyDollar size={50} />} />
          </div>
    </>
  )
}

export default AuditionIncome